// enumHelpers.ts
import {apiUrl} from "../../services";

export function resolveEnumUrl(key: string): string | undefined {
    if (!key) return undefined;

    if (key.includes(".")) return key;

    return (apiUrl.enums as any)?.[key];
}
